export enum GradientGetter {
    primaryColor = 'primaryColor',
    secondaryColor = 'secondaryColor',
    gradientPrimaryRgb = 'gradientPrimaryRgb',
    gradientSecondaryRgb = 'gradientSecondaryRgb',
    gradientPrimaryRgba = 'gradientPrimaryRgba',
    gradientSecondaryRgba = 'gradientSecondaryRgba',
}
